import { useUser } from '@store'

import { ProfileAvatarsActionsProvider } from '../../contexts'
import { ProfileAvatars } from '../ProfileAvatars'
import { SpiralSelector } from '../SpiralSelector'
import { StarSlider } from '../StarSlider'
import styles from './ProfileEdit.module.scss'

export const ProfileEdit = () => {
  const { profile } = useUser()

  if (!profile) {
    return null
  }

  return (
    <div className={styles.container}>
      <ProfileAvatarsActionsProvider>
        <ProfileAvatars />
      </ProfileAvatarsActionsProvider>
      <StarSlider />
      <SpiralSelector />
    </div>
  )
}
